import { DATE_FILTER_OPTIONS } from './constants';

export const getMaxDecimalsForCurrency = (currency) => {
    const length = String(currency || '').trim().length;
    if (length === 3) return 2;
    if (length === 4) return 6;
    return 2;
}

export const formatAmount = (value, maxDecimals = 6) => {
    if (value == null || isNaN(Number(value))) return '-';
    return Number(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: maxDecimals,
    });
}

export const toIsoDate = (d) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

/** Resolves a DATE_FILTER_OPTIONS value into { startDate, endDate } (YYYY-MM-DD), used by <DateFilter /> */
export const getDateFilterRange = (filter) => {
    const today = new Date();
    const todayIso = toIsoDate(today);

    if (filter === DATE_FILTER_OPTIONS.MONTH_TILL_DATE) {
        const start = new Date(today.getFullYear(), today.getMonth(), 1);
        return { startDate: toIsoDate(start), endDate: todayIso };
    }
    if (filter === DATE_FILTER_OPTIONS.LAST_MONTH) {
        const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const end = new Date(today.getFullYear(), today.getMonth(), 0);
        return { startDate: toIsoDate(start), endDate: toIsoDate(end) };
    }
    if (filter === DATE_FILTER_OPTIONS.LAST_90_DAYS) {
        const start = new Date(today);
        start.setDate(start.getDate() - 89); // 90 days ago
        return { startDate: toIsoDate(start), endDate: todayIso };
    }
    return { startDate: undefined, endDate: undefined };
}

/** Resolves a period tab ("MTD" | "Last 30d" | "Last 90d" | "Custom") into { fromDate, toDate } (YYYY-MM-DD) */
export const resolvePeriodRange = (period, customFrom, customTo) => {
    const today = new Date();
    const to = toIsoDate(today);

    if (period === "MTD") {
        const start = new Date(today.getFullYear(), today.getMonth(), 1);
        return { fromDate: toIsoDate(start), toDate: to };
    }
    if (period === "Last 30d") {
        const start = new Date(today);
        start.setDate(start.getDate() - 30);
        return { fromDate: toIsoDate(start), toDate: to };
    }
    if (period === "Last 90d") {
        const start = new Date(today);
        start.setDate(start.getDate() - 90);
        return { fromDate: toIsoDate(start), toDate: to };
    }
    if (period === "Custom") {
        return { fromDate: customFrom || undefined, toDate: customTo || undefined };
    }
    return { fromDate: undefined, toDate: undefined };
}